module.exports = __webpack_public_path__ + "img/card-2.27308ec5.svg";